import React, {lazy, Suspense, useEffect, useState, useRef } from "react"; // ⬅️ doplň useRef
import HeroSection from "../components/HeroSection"; // Importujeme Hero sekci
import useViewportHeight from "../hooks/useViewportHeight";
import styles from "./About.module.css";
const About = lazy(() => import("./About"));
const Graphic = lazy(() => import("./Graphic"));
const Contact = lazy(() => import("./Contact"));
const Footer = lazy(() => import("./Footer"));
const Voucher = lazy(() => import("./Voucher"));

function Home() {
    const [isMobile, setIsMobile] = useState(false);

    const [voucherSectionHeight, setVoucherSectionHeight] = useState("100vh");
    const voucherSectionRef = useRef(null);
    const scrollWrapperRef = useRef(null)


    const aboutTriggerRef = useRef(null);
    const [showVoucher, setShowVoucher] = useState(false);
    const voucherTriggerRef = useRef(null);

    useEffect(() => {
        const checkMobile = () => {
            const width = window.innerWidth;
            const height = window.innerHeight;
            const isPortrait = height > width;
            const newIsMobile = width < 768 || isPortrait;

            setIsMobile(newIsMobile);
        };
        checkMobile();
        window.addEventListener("resize", checkMobile);
        return () => window.removeEventListener("resize", checkMobile);
    }, []);




    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.intersectionRatio >= 0.25 && !showVoucher) {
                        setShowVoucher(true);
                    }
                });
            },
            {
                root: null, // 👈 změna zde
                threshold: 0.25
            }
        );

        if (voucherTriggerRef.current) {
            observer.observe(voucherTriggerRef.current);
        }

        return () => observer.disconnect();
    }, [showVoucher]);


    return (
    <div
        ref={scrollWrapperRef}
        className={"no-scrollbar"} style={{
        background:"#000",
        overflowX: "hidden" ,
        zIndex:100,
        position:"relative",
        height: "100dvh",
        minHeight: "100dvh",
        overflowY: "scroll",
        WebkitOverflowScrolling: "touch",
        scrollbarWidth: "none",
    }}>
        {/* Hero sekce */}

        <section style={{
            height: "100dvh",
            backgroundColor: "black",
            position: "relative",
            zIndex: 101,
            padding: isMobile ?  "clamp(1.44rem, 8vw, 12rem) clamp(1.44rem, 5vw, 12rem) 0 clamp(1.44rem, 5vw, 12rem)" : "clamp(1.44rem, 5vw, 12rem)",
            overflow: "visible",
        }} >
            <HeroSection scrollWrapperRef={scrollWrapperRef}  />
            <div className={styles.seoText}>
                <h1>Jakub Vychodil Art | Tetovací studio v Moravských Budějovicích</h1>
            </div>
        </section>



        {/* Sekce Graphic */}
        <section id="graphic"
                 aria-hidden="true"
                 role="presentation"
                 style={{
                     background: "#000",
                     height: "calc(var(--vh, 1vh) * 100)",
                     zIndex: 100
                 }}
                 ref={voucherTriggerRef}
        >
            <Suspense fallback={null}>
                <Graphic scrollWrapperRef={scrollWrapperRef} isMobile={isMobile} />
            </Suspense>
        </section>

        {/* Sekce O nás */}


            <section
                id="about"
                style={{
                    background: "#000",
                    height: isMobile ? "190vw" : "calc(var(--vh, 1vh) * 100)",
                    zIndex: 100,
                    position: "relative"
                }}
                ref={aboutTriggerRef}
            >
                <Suspense fallback={null}>
                    {showVoucher ? <About scrollWrapperRef={scrollWrapperRef} isMobile={isMobile}/> : <div style={{display:"flex",justifyContent:"center",alignItems:"center",height:"100%"}}>
                        <p style={{fontSize: "clamp(1rem, 10vw, 4rem)",color:"white",fontFamily: "Inter regular, sans-serif"}}>
                            Načítání
                        </p>
                    </div>}
                </Suspense>
                <div className={styles.seoText}>
                    <h2>O mně</h2>
                    <p>
                        Jsem tatér z Moravských Budějovic a provozuji vlastní tetovací studio, kam se sjíždějí klienti z celého regionu – od Znojma po Jihlavu.
                    </p>
                    <p>
                        Tetování se věnuji už dlouho a pořád s láskou. Jako tatér kladu důraz na detail a individuální přístup ke každému klientovi. Moje tetovací studio v Moravských Budějovicích navštěvují nejen místní, ale často i klienti z okolních měst, jako jsou Třebíč, Znojmo, Dačice nebo Jemnice. Díky výhodné poloze mě snadno najdou také lidé z Telče, Moravského Krumlova nebo Jaroměřic nad Rokytnou.
                    </p>
                    <p>
                        Kromě práce v tetovacím studiu se věnuji také dceři a občas si najdu čas na sport.
                    </p>
                    <p>
                        Ale tohle by mělo být spíš o tobě a o tetování, které si z mého studia odneseš, protože přesně o to ti přece jde.
                    </p>
                    <p>
                        Pokud máš svůj vysněný motiv pro tetování, rád ti ho zvěčním. A pokud ještě nemáš jasnou představu, jak má tetování vypadat, můžeme se sejít osobně na konzultaci, kde ti pomůžu doladit všechny detaily.
                    </p>
                    <p>
                        Objednávky bohužel nemůžu vyřizovat okamžitě po napsání zprávy, ale snažím se odpovídat alespoň jednou denně. Nejlépe uděláš, když mi necháš zprávu s popisem své představy o tetování a případně připojíš i své časové možnosti. Ozvu se ti co nejdřív.
                    </p>
                </div>
            </section>


        {/* Sekce Voucher */}
        <Suspense fallback={null}>
            <section
                id="voucher"
                ref={voucherSectionRef}
                style={{
                    height: voucherSectionHeight === "0vh" ? "0vh" : "calc(var(--vh, 1vh) * 100)",
                    background: "black",
                    transition: "height 0.5s ease-in-out",
                    zIndex: 1
                }}
            >
                {showVoucher ? <Voucher
                    scrollWrapperRef={scrollWrapperRef}
                isMobile={isMobile}
                onVoucherComplete={() => setVoucherSectionHeight("0vh")}
                voucherSectionRef={voucherSectionRef}
                /> : <div style={{display:"flex",justifyContent:"center",alignItems:"center",height:"100%"}}>
                        <p style={{fontSize: "clamp(1rem, 10vw, 4rem)",color:"white",fontFamily: "Inter regular, sans-serif"}}>
                            Načítání
                        </p>
                     </div>}
                <div className={styles.seoText}>
                    <h2>Dárkový poukaz na tetování</h2>
                    <p>
                        Potěš blízké originálním dárkem – dárkový poukaz na tetování v tetovacím studiu
                        Jakub Vychodil Art v Moravských Budějovicích. Poukaz lze uplatnit na tetování dle
                        vlastního výběru motivu.
                    </p>
                </div>
            </section>
        </Suspense>



        {/* Sekce Kontakt */}
        <section id="contact" style={{
            height: isMobile ? "calc(100vw + 120vw)" : "calc(var(--vh, 1vh) * 100)",
            background: "#000",
            zIndex: 100
        }}>
            <Contact />
        </section>

        <Suspense fallback={null}>
            {/* Footer */}
            <section
                id="footer"

                style={{
                height: "calc(var(--vh, 1vh) * 50)",
                background: "#000",
                zIndex: 99
            }}>
                <Footer
                    scrollWrapperRef={scrollWrapperRef}
                    isMobile={isMobile}
                />
            </section>
        </Suspense>
    </div>
    );
}



export default Home;
